export const CHATBOT_NAME = "Clara";
